import { render, staticRenderFns } from "./CardClientNewOt.vue?vue&type=template&id=55617573&scoped=true"
import script from "./CardClientNewOt.vue?vue&type=script&lang=js"
export * from "./CardClientNewOt.vue?vue&type=script&lang=js"
import style0 from "./CardClientNewOt.vue?vue&type=style&index=0&id=55617573&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55617573",
  null
  
)

export default component.exports